import { cloneDeep } from 'lodash';
import { ordersFormating } from '../../../apis/ordersFormating';
import { PlaceStoreContextReadOnly } from '../../Place/PlaceReducer';

const newOrder = (state, payload) => {
  const newState = cloneDeep(state);
  let details = null;
  try {
    details = JSON.parse(payload.details);
  } catch (error) {
    details = null;
  }

  const newOrder = {
    id: payload.id,
    order_id: payload.orderId,
    place_id: payload.placeId,
    point_id: payload.pointId,
    products: payload.products,
    type: payload.type,
    user_device: payload.userDevice,
    user_id: payload.userId,
    updated_at: Date.now(),
    services: JSON.parse(payload.services),
    details,
    rejected: null,
    completed: null,
  };
  

  const orders = ordersFormating([newOrder], PlaceStoreContextReadOnly.state.products.productId__product);
  newState.activeEvents[payload.orderId] = orders[payload.orderId];
  return newState;
};

export { newOrder };
